<template>
  <span>{{ name }}</span>
</template>

<script>
import { getUserName } from "@/dashboard/services";

export default {
  computed: {
    name() {
      return getUserName(this.$store.state.user);
    },
  },
};
</script>
